import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import { useSearchParams } from 'react-router-dom';

const useGetBrandsDropdown = () => {
  const Api = useApi()
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');   

  const initialFilters = {
    user: id,
  }
  const {filters} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery('/suppliers/users/mapped/brands/list', {
    queryId: 'supplier-brands-dropdown',
    filters,
  })

  return {
    allBrands: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetBrandsDropdown